import Swiper from 'swiper';
import 'swiper/css/bundle';

export default function Slider() {
  const swiper = new Swiper("#image-slider", {
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: "auto",
        spaceBetween: 30,
      },
    }
  });
}